var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconUtilityNonMains48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00024 24.5029L10.0002 24.5029",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7075 13.7031H36.6348C37.5289 13.7031 38.2536 14.3759 38.2536 15.2057V33.8005C38.2536 34.6304 37.5289 35.3031 36.6348 35.3031H25.7075C20.3431 35.3031 15.9944 31.2667 15.9944 26.2875V22.7188C15.9944 17.7396 20.3431 13.7031 25.7075 13.7031Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4448 20.9178L30.8896 24.246L27.4448 27.5743L24.0001 24.246L27.4448 20.9178Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2537 19.7031H42.2751C42.786 19.7031 43.2002 20.2404 43.2002 20.9031C43.2002 21.5659 42.786 22.1031 42.2751 22.1031H38.2537V19.7031Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2537 26.9033H42.2751C42.786 26.9033 43.2002 27.4406 43.2002 28.1033C43.2002 28.7661 42.786 29.3033 42.2751 29.3033H38.2537V26.9033Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4864 19.7031H9.74658V29.3031H16.4864C16.1259 28.3602 15.9297 27.3451 15.9297 26.2875V22.7188C15.9297 21.6611 16.1259 20.646 16.4864 19.7031Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74658 19.7031V19.1031H9.14658V19.7031H9.74658ZM16.4864 19.7031L17.0468 19.9174L17.3581 19.1031H16.4864V19.7031ZM9.74658 29.3031H9.14658V29.9031H9.74658V29.3031ZM16.4864 29.3031V29.9031H17.3581L17.0468 29.0889L16.4864 29.3031ZM9.74658 20.3031H16.4864V19.1031H9.74658V20.3031ZM10.3466 29.3031V19.7031H9.14658V29.3031H10.3466ZM16.4864 28.7031H9.74658V29.9031H16.4864V28.7031ZM17.0468 29.0889C16.7119 28.2128 16.5297 27.2702 16.5297 26.2875H15.3297C15.3297 27.42 15.5399 28.5076 15.926 29.5174L17.0468 29.0889ZM16.5297 26.2875V22.7188H15.3297V26.2875H16.5297ZM16.5297 22.7188C16.5297 21.7361 16.7119 20.7935 17.0468 19.9174L15.926 19.4889C15.5399 20.4986 15.3297 21.5862 15.3297 22.7188H16.5297Z",
    fill: "#1E1E1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconUtilityNonMains48);
export default __webpack_public_path__ + "static/media/pictogramBeaconUtilityNonMains48.f5f75890b1ca293099e8919194b304da.svg";
export { ForwardRef as ReactComponent };